<template>
  <div>
    <Article :pageType="4"></Article>
  </div>
</template>

<script>


export default {
  name: "articleCase",
  components: {
    Article: () => import("@/view/article/list"),
  },

  created() { 

  setTimeout(()=>{
     
  },1000)
  },
};
</script>
